import { render } from "./ktyjBorder.vue?vue&type=template&id=28ce294d&scoped=true"
import script from "./ktyjBorder.vue?vue&type=script&lang=js"
export * from "./ktyjBorder.vue?vue&type=script&lang=js"

import "./ktyjBorder.vue?vue&type=style&index=0&id=28ce294d&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ce294d"]])

export default __exports__